export default __webpack_public_path__ + "static/media/OLINEOLogo.d5bb788c.png";